import { useEffect, useRef, useState } from "react";
import { useFramePreviews } from "@/interface/RightSheet/Presentations/PresentationsNavigator/PresentationView/hooks/useFramePreviews";
import type { PresentationModeData } from "@/interface/RightSheet/Presentations/PresentationsNavigator/types";

type PresentationWithPreviews = PresentationModeData & {
    previews: Record<string, string>;
};

export const usePresentation = (
    basePresentation: PresentationModeData | null,
): PresentationWithPreviews | null => {
    const generatePreviews = useFramePreviews(basePresentation?.frames || []);
    const [presentation, setPresentation] = useState<PresentationWithPreviews | null>(null);

    const previewsRef = useRef<Record<string, string>>({});

    useEffect(() => {
        if (!basePresentation) return;

        let cancelled = false;

        const run = async () => {
            const previews = await generatePreviews();

            if (cancelled) {
                Object.values(previews).forEach(URL.revokeObjectURL);
                return;
            }

            Object.values(previewsRef.current).forEach(URL.revokeObjectURL);

            previewsRef.current = previews;

            setPresentation({
                ...basePresentation,
                previews,
            });
        };

        run();

        return () => {
            cancelled = true;
        };
    }, [basePresentation, generatePreviews]);

    useEffect(() => {
        return () => {
            Object.values(previewsRef.current).forEach(URL.revokeObjectURL);
        };
    }, []);

    return presentation;
};
